module.exports = __webpack_public_path__ + "static/ekko-app-og-ekko-updater-5c5f8761ab1e40cb37426cda1326cd57.jpg";